import { Box, Button, Stack, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { AiStudioHandoff } from "hooks/useAiStudioChat";

/**
 * Shown when the Assistant decided the request belongs to another screen --
 * today, a BPMN modelling request going to the modeller, whose own AI drawer
 * has the canvas, the current diagram and the real participant list.
 *
 * The card is an offer, not a redirect: nothing happens until the user presses
 * the button. It stays in the conversation afterwards, so coming back to the
 * chat still shows where that request went and lets them open it again.
 */

interface HandoffCardProps {
  handoff: AiStudioHandoff;
  onOpen: () => void;
}

const HandoffCard: React.FC<HandoffCardProps> = ({ handoff, onOpen }) => (
  <Box
    sx={{
      border: (theme) => `1px solid ${theme.palette.divider}`,
      borderRadius: 2,
      p: 1.5,
      my: 0.5,
    }}
  >
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      <OpenInNewIcon fontSize="small" color="primary" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {handoff.label}
      </Typography>
    </Stack>
    <Typography variant="body2" color="text.secondary">
      {handoff.message}
    </Typography>
    <Button
      size="small"
      variant="contained"
      onClick={onOpen}
      sx={{ textTransform: "none", mt: 1.5 }}
    >
      {handoff.cta}
    </Button>
  </Box>
);

export default HandoffCard;
